module.exports = __webpack_public_path__ + "img/logo.17c42f15.png";